module.exports = __webpack_public_path__ + "static/media/sm_4.25a0f920.svg";